import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import "@/App.css";
import HomePage from "@/pages/HomePage";
import ImpressumPage from "@/pages/ImpressumPage";
import DatenschutzPage from "@/pages/DatenschutzPage";
import CaseStudyPage from "@/pages/CaseStudyPage";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import CookieConsent from "@/components/CookieConsent";
import NetworkBackground from "@/components/NetworkBackground";
import IntroAnimation from "@/components/IntroAnimation";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <div className="relative min-h-screen bg-[#FAFAFA]">
        <ScrollToTop />
        <IntroAnimation />
        {/* Gradient accent line at top */}
        <div className="fixed top-0 left-0 right-0 h-[2px] gradient-top-line z-[60]" />
        <NetworkBackground />
        <Navbar />
        <main className="relative z-10">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/impressum" element={<ImpressumPage />} />
            <Route path="/datenschutz" element={<DatenschutzPage />} />
            <Route path="/case-study/:slug" element={<CaseStudyPage />} />
          </Routes>
        </main>
        <Footer />
        <CookieConsent />
      </div>
    </BrowserRouter>
  );
}

export default App;
